import { getWorkOrderLOTO } from "@/pages/work-orders/repositorie/WorkOrdersRepositorie";
import { useWorkOrderModalsContext } from "@/shared/work-orders-modals/context/work-order-modals.context";
import { get } from "lodash-es";

type Props = {
	setIsWorkOrderLOTOLoading: (isLoading: boolean) => void;
	setWorkOrderLOTOError: (err: string) => void;
	WorkOrderId: number | null;
};

export const useSearchWorkOrderLOTO = ({
	WorkOrderId,
	setIsWorkOrderLOTOLoading,
	setWorkOrderLOTOError,
}: Props) => {
	const {
		actions: { setWorkOrderLOTOList },
	} = useWorkOrderModalsContext();

	return async () => {
		setWorkOrderLOTOList([]);
		setIsWorkOrderLOTOLoading(true);
		const res = await getWorkOrderLOTO(WorkOrderId as number);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			setWorkOrderLOTOList(rowsSource);
			setIsWorkOrderLOTOLoading(false);
		} else {
			setIsWorkOrderLOTOLoading(false);
			setWorkOrderLOTOError(res.message);
		}
	};
};
